import { useNavigate } from 'react-router-dom';

const useCustomNavigate = () => {
  const navigate = useNavigate();

  const customNavigate = (path, params) => {
  let encryptedPath = path;

    if (params) {
      const encodedParams = btoa(JSON.stringify(params));
      //const encodedParams = encryptAes(JSON.stringify(params));
      encryptedPath = `${path}?params=${encodedParams}`;
    }
    if (params && params.state) {
      navigate(encryptedPath, params.state);
    } else {
      navigate(encryptedPath);
    }
  };

  return customNavigate;
};

export default useCustomNavigate;